
import React, { useEffect, useState } from "react";
import "./dashboard.css";
import { FaBell, FaUserCircle ,FaBars} from 'react-icons/fa';
import { FaBarsStaggered } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { collapse } from "../redux/reducer/SideBarReducer";
import { useNavigate } from "react-router-dom";
import { clearUser } from "../redux/reducer/AdminReducer";
const Header = () => {
   const navigate= useNavigate();
 const dispatch = useDispatch();
 const isCollapsed = useSelector((state)=>state.sidebar.value)
  const [isProfileMenuVisible, setIsProfileMenuVisible] = useState(false);
  const [isNotificationsMenuVisible, setIsNotificationsMenuVisible] =
    useState(false);

  const handleProfileHover = () => setIsProfileMenuVisible(true);
  const handleProfileLeave = () => setIsProfileMenuVisible(false);

  const handleNotificationsHover = () => setIsNotificationsMenuVisible(true);
  const handleNotificationsLeave = () => setIsNotificationsMenuVisible(false);

  const handleSidebarToggle = () => {
    dispatch(collapse()) 
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        dispatch(collapse());
      }
    };

    handleResize(); 
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch]);

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <img
            src={require("../../assets/HKCL_Logo.png")}
            alt="SAS Logo"
            className="logo-image"
          />
          <span className="logo-text" style={{color:"#008d96"}}>HKCL</span>
       
        {!isCollapsed &&  <FaBars size={24} style={{color:"#008d96"}} className="ms-5" onClick={handleSidebarToggle}/>}
        {isCollapsed &&  <FaBarsStaggered size={24} style={{color:"#008d96"}} className="ms-5" onClick={handleSidebarToggle}/>}
        </div>
        <div className="user-info me-3">
        

          {/* <div
            className="notifications"
            onMouseEnter={handleNotificationsHover}
            onMouseLeave={handleNotificationsLeave}
          >
            <FaBell size={24} />
            {isNotificationsMenuVisible && (
              <div className="notifications-menu">
                <ul>
                  <li>New message from John</li>
                  <li>System update available</li>
                  <li>Reminder: Meeting at 3 PM</li>
                </ul>
              </div>
            )}
          </div> */}
          <div
            className="profile"
            onMouseEnter={handleProfileHover}
            onMouseLeave={handleProfileLeave}
          >
            <FaUserCircle size={24}/>
           
            {isProfileMenuVisible && (
              <div className="profile-menu">
                 <span className="username" style={{color:"white"}}> Welcome Admin</span>
                <ul>
                  
                  <li onClick={()=>{navigate("/login");
                  dispatch(clearUser());
                    sessionStorage.removeItem("userToken")
                    sessionStorage.removeItem("userDetails")
                  }}>Logout</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
